export const modalTitle = {
  1: "新增一级字典",
  2: "新增下级字典",
  3: "修改字典"
};
